import React, { useContext } from 'react';

import { Container } from '../common';
import type { EventTypeEvaluationsContextType } from '../context';
import { EventTypeEvaluationsProvider } from '../context';
import { UserContext } from '~/dashboard/context';
import { ExternalAccountCreatedTabs } from './ExternalAccountCreatedTabs';
import { ExternalAccountCreatedOverview } from './ExternalAccountCreatedOverview';
import { useRiskData } from '../../RiskRatingCard/useRiskData';

const ExternalAccountCreated: React.FC<EventTypeEvaluationsContextType> = props => {
  const { evaluation } = props;
  const { permissions } = useContext(UserContext);
  const hasReadApplicationVersionsPermission = !!permissions?.['READ:ApplicationVersions:null'];
  /* ---------- CRA Logic ---------- */
  const {
    showRiskTab: shouldRenderRiskTab,
    ...riskData
  } = useRiskData({
    riskScoreData: evaluation.final_response.summary?.risk_score,
  });

  const {
    showRiskTab: shouldRenderSessionRiskTab,
    ...sessionRiskData
  } = useRiskData({
    riskScoreData: evaluation.final_response.summary?.session_risk_score,
  });

  /* ---------- vvvvvvvvv ---------- */

  return (
    <EventTypeEvaluationsProvider {...props}>
      <Container
        evaluationToken={evaluation.evaluation_token}
        entityToken={evaluation.entity_token}
        workflowToken={evaluation.application_token}
        workflowVersion={evaluation.public_version}
      >
        {shouldRenderRiskTab || shouldRenderSessionRiskTab ? (
          <ExternalAccountCreatedTabs
            riskData={riskData}
            sessionRiskData={sessionRiskData}
            shouldRenderRiskTab={shouldRenderRiskTab}
            shouldRenderSessionRiskTab={shouldRenderSessionRiskTab}
            canViewRiskFormula={hasReadApplicationVersionsPermission}
          />
        ) : (
          <ExternalAccountCreatedOverview />
        )}
      </Container>
    </EventTypeEvaluationsProvider>
  );
};

export default ExternalAccountCreated;
